import { Link } from "react-router";

export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <Link
      to="/"
      className={`brand ${compact ? "brand--compact" : ""}`}
      aria-label="10thingz home"
    >
      <span className="brand__mark" aria-hidden="true">
        <span>10</span>
      </span>
      <span className="brand__word">10thingz</span>
    </Link>
  );
}
